// src/components/ServiceCard.js
import React from "react";
import "./ServiceCard.css";
import { buildUrlWithUTM } from "../utils/utmHelper";

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="service-card">
      <a href={buildUrlWithUTM("https://doodley.in/BookHomeVisit")}>
        <img src={icon} alt={title} className="service-icon" />
        <h3>{title}</h3>
        <p>{description}</p>
      </a>
    </div>
  );
};

export default ServiceCard;
